import React, { Component } from 'react'
import './howtowork.css'

class HowToWorkComponent extends Component {
  render() {
    return (
      <>
        <div className="timeline-container">
          <h1>Así funciona en la práctica</h1>
          <div className="timeline">
            <div className="timeline-item">
              <div className="step-circle">Paso 1</div>
              <div className="timeline-content">
                <h3>
                  Nos das tus datos reales <span>LISTO</span>
                </h3>
                <p>Edad, peso, hábitos, preferencias, actividad, objetivos.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="step-circle">Paso 2</div>
              <div className="timeline-content">
                <h3>Diseñamos tu sistema alimenticio bioindividual</h3>
                <p>
                  Calorías, macros, estructura de comidas, opciones flexibles,
                  lista de alimentos, recomendaciones de suplementos.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="step-circle">Paso 3</div>
              <div className="timeline-content">
                <h3>Recibes tu plan completo</h3>
                <p>Optimizado, claro, listo para aplicar de inmediato</p>
              </div>
            </div>
          </div>
          <p>Sin apps. Sin suscripciones. Sin depender de nadie.</p>
        </div>
      </>
    )
  }
}
export default HowToWorkComponent
